import { useEffect, useState, useRef } from "react";
import "./challenge-play.css";
import Logo from "../../../ui/atoms/logo/Logo";
import TimerCounterDown from "../components/timer-counter-down/TimerCounterDown";
import Instructions from "../../../ui/organisms/instructions/Instructions";
import BackgroundPaths from "../../../ui/molecules/background-paths/BackgroundPaths";
import ChallengeQuestion from "../components/challenge-question/ChallengeQuestion";
//
import { useFullscreen } from "../../../app/providers/useFullscreen";
import FullscreenModal from "../../../ui/organisms/fullscreen-modal/FullscreenModal";
import { FaRegCircleDot } from "react-icons/fa6";
import { LuSend } from "react-icons/lu";
import { BsCheck2All } from "react-icons/bs";
import { useSelector } from "react-redux";

import moment from "moment";

const ChallengePlay = () => {
  const wrapperRef = useRef(null);
  const { isFullscreen, enter, exit } = useFullscreen();
  const [isInstructionReaded, setIsInstructionReaded] = useState(false);
  const [isOpenChat, setIsOpenChat] = useState(false);
  //
  const [skipModalOpen, setSkipModalOpen] = useState(false);
  const [exitModalOpen, setExitModalOpen] = useState(false);
  //
  //
  //
  const [questionTiming, setQuestionTiming] = useState(0);
  const [isQuestionStarted, setIsQuestionStarted] = useState(false);
  const [isQuestionStopped, setIsQuestionStopped] = useState(false);
  const [pointsGain, setPointsGain] = useState(0);
  const [totalPoints, setTotalPoints] = useState(0);
  const [actualQuestion, setActualQuestion] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [responseTiming, setResponseTiming] = useState(0);
  const [currentTimerTiming, setCurrentTimerTiming] = useState(0);
  const [isSkipped, setIsSkipped] = useState(false);
  //
  const currentAssessment = useSelector(
    (state) => state?.challengeState?.currentAssessment,
  );

  const keyValue = currentAssessment?.mode;
  const keyId =
    keyValue === "AT"
      ? currentAssessment?.admission_test_id
      : currentAssessment?.challenge_id;
  const keyType = keyValue === "AT" ? null : currentAssessment?.challenge_type;
  const keyPlayer = keyValue === "AT" ? null : currentAssessment?.request_id;

  const toggleFullscreen = () => {
    if (isFullscreen) exit();
    else enter(wrapperRef.current);
  };

  const onHandleInstructions = () => {
    setIsInstructionReaded(true);
    toggleFullscreen();
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement && isInstructionReaded) {
        setExitModalOpen(true);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, [isInstructionReaded]);

  useEffect(() => {
    if (skipModalOpen) {
      setIsSkipped(true);
    }
  }, [skipModalOpen]);

  return (
    <div className="challenge-play-stage" ref={wrapperRef}>
      <>
        {" "}
        <FullscreenModal
          open={skipModalOpen}
          title="Skip this question?"
          description="This question will be considered failed."
          confirmText="Yes, Skip"
          cancelText="No, Keep"
          onConfirm={() => {
            setSkipModalOpen(false);
            // logique skip
          }}
          onCancel={() => setSkipModalOpen(false)}
        />
        <FullscreenModal
          open={exitModalOpen}
          title="Quit challenge?"
          description="You won’t be able to continue this challenge."
          confirmText="Quit"
          cancelText="Continue"
          onConfirm={() => {
            setExitModalOpen(false);
            // logique exit
          }}
          onCancel={() => {
            setExitModalOpen(false);
            enter(wrapperRef.current); // retour fullscreen auto
          }}
        />
      </>
      <div className="main-stage">
        <div className="main-stage-head">
          <div className="main-stage-head-container">
            <div className="w-fit-content h-full head-mark d-flex flex-col align-center justify-center">
              <Logo to={""} width={"120px"} />
              <span>{keyValue === "AT" ? "Admission Test" : "Challenge"}</span>
            </div>
            <div className="w-fit-content h-full">
              <TimerCounterDown
                duration={parseInt(questionTiming)}
                isQuestionStarted={isQuestionStarted}
                isQuestionStopped={isQuestionStopped}
                setResponseTiming={setResponseTiming}
                setCurrentTimerTiming={setCurrentTimerTiming}
              />
            </div>
            <div className="head-score">
              <div className="h-s-wrapper">
                <span>You won (Points) :</span>
                <p>
                  {pointsGain} / {totalPoints}
                </p>
              </div>
            </div>
            <div className="head-options">
              <span>
                {totalQuestions - actualQuestion} Questions left over{" "}
                {totalQuestions}
              </span>
              {questionTiming > 0 && (
                <button
                  className="button is-next"
                  onClick={() => setSkipModalOpen(true)}
                >
                  Skip this Question ⏭️
                </button>
              )}
              {keyValue === "challenge" && (
                <button
                  className="button is-chat"
                  onClick={() => setIsOpenChat(true)}
                >
                  💬 Open Team's Discussion!
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="main-stage-body">
          <div className="main-stage-body-inner">
            <BackgroundPaths isBackground={false} />
          </div>
          {isInstructionReaded && (
            <div className="main-stage-body-outer">
              <ChallengeQuestion
                assessmentId={keyId}
                assessmentMode={keyValue}
                assessmentType={keyType}
                playerRequestId={keyPlayer}
                setQuestionTiming={setQuestionTiming}
                setIsQuestionStarted={setIsQuestionStarted}
                isQuestionStopped={isQuestionStopped}
                setIsQuestionStopped={setIsQuestionStopped}
                setPointsGain={setPointsGain}
                setTotalPoints={setTotalPoints}
                setActualQuestion={setActualQuestion}
                setTotalQuestions={setTotalQuestions}
                responseTiming={responseTiming}
                currentTimerTiming={currentTimerTiming}
                isSkipped={isSkipped}
                setIsSkipped={setIsSkipped}
              />
            </div>
          )}
        </div>
      </div>
      {/* Insctruction Section */}
      <div
        className={
          isInstructionReaded
            ? "instruction-stage slide-out"
            : "instruction-stage slide-in"
        }
      >
        <Instructions
          title={keyValue === "admission-test" ? "Admission Test" : "Challenge"}
          type={keyValue === "admission-test" ? "test" : "common"}
          onAction={onHandleInstructions}
        />
      </div>
      {/* Discussion section */}
      <div
        className={
          isOpenChat
            ? "discussion-stage slide-in"
            : "discussion-stage slide-out"
        }
      >
        <div className="discussion-stage-head">
          <div className="row">
            <h3>Team : Real Madrid</h3>
            <button
              className="button is-chat"
              onClick={() => setIsOpenChat(false)}
            >
              💬 Close Discussion!
            </button>
          </div>
          <div className="tiles">
            <div className="tile">
              <FaRegCircleDot className="icon" />
              <span>Player Member 1</span>
            </div>
            <div className="tile">
              <FaRegCircleDot className="icon" />
              <span>Player Member 2</span>
            </div>
            <div className="tile">
              <FaRegCircleDot className="icon" />
              <span>Player Member 3</span>
            </div>
            <div className="tile">
              <FaRegCircleDot className="icon" />
              <span>Player Member 4</span>
            </div>
            <div className="tile">
              <FaRegCircleDot className="icon" />
              <span>Player Member 5</span>
            </div>
          </div>
        </div>
        <div className="discussion-stage-box">
          <div className="discussion-date-grouped">
            <div className="tick-wrapper">
              <span className="tick-date">Today</span>
            </div>
            <div className={"msg-element is-right"}>
              <h3 className="msg-e-top">{"Player member 1"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element"}>
              <h3 className="msg-e-top">{"Player member 2"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element"}>
              <h3 className="msg-e-top">{""}</h3>
              <div className="msg-e-text">{"msg text Player member 2"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element"}>
              <h3 className="msg-e-top">{"Player member 3"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element"}>
              <h3 className="msg-e-top">{"Player member 4"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element is-right"}>
              <h3 className="msg-e-top">{"Player member 1"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element is-right"}>
              <h3 className="msg-e-top">{"Player member 1"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
            <div className={"msg-element is-right"}>
              <h3 className="msg-e-top">{"Player member 1"}</h3>
              <div className="msg-e-text">{"msg text"}</div>
              <div className="msg-e-bottom">
                <span>{moment().fromNow()}</span>
                <BsCheck2All className="icon is-delivered" />
              </div>
            </div>
          </div>
        </div>
        <div className="discussion-stage-footer">
          <textarea wrap="soft" placeholder="Type your message..."></textarea>
          <span>
            <LuSend className="icon" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChallengePlay;
